<template>
  <div>
    <main class="ts-app-shell">
      <el-drawer
        title="Notifications"
        :visible.sync="table"
        direction="rtl"
        size="50%"
        :before-close="reloadScrollbar"
      >
        <el-table
          ref="multipleTable"
          :data="notifications"
          style="width: 100%"
          height="700"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column width="55">
            <template slot="header">
              <el-button
                v-if="multipleSelection.length !== 0"
                class="ts-btn-small invt-action"
                @click="removeNotifications"
                ><i class="fas fa-trash-alt"></i
              ></el-button>
            </template>
          </el-table-column>

          <el-table-column property="capturedType" width="auto">
            <template scope="scope">
              <div class="payload-cell">
                <!-- Capture type = 0 - Skills Profile updated -->
                <span
                  v-if="scope.row.capturedType == 0"
                  @click="readNotification(scope.row)"
                >
                  <div class="ts-notifications__row-container">
                    <span class="ts-notifications-title">
                      <i class="far fa-address-card"></i>
                      <strong>{{ scope.row.capturedTypeName }}</strong>
                    </span>
                    <span class="ts-notifications-info">
                      <span class="ts-notifications-message">
                        <strong
                          >{{
                            scope.row.payload.sgaEmployeeInfo
                              .confirmEmailAddress
                          }}
                        </strong>
                        updated their Skills Profile
                      </span>
                      <span class="ts-notifications-time">{{
                        scope.row.updated
                      }}</span>
                    </span>
                  </div>
                </span>
                <!-- Capture type = 1 - Baseline Triage updated -->
                <span
                  v-if="scope.row.capturedType == 1"
                  @click="readNotification(scope.row)"
                >
                  <div class="ts-notifications__row-container">
                    <span class="ts-notifications-title">
                      <i class="fas fa-layer-group"></i>
                      <strong>{{ scope.row.capturedTypeName }}</strong>
                    </span>
                    <span class="ts-notifications-info">
                      <span class="ts-notifications-message">
                        Baseline Triage has been updated
                      </span>
                      <span class="ts-notifications-time">{{
                        scope.row.updated
                      }}</span>
                    </span>
                  </div>
                </span>
                <!-- Capture type = 3,4,5 - Recruitment, Hours Change, Temp Hours Change -->
                <span
                  v-if="
                    scope.row.capturedType != 0 && scope.row.capturedType != 1
                  "
                  @click="readNotification(scope.row)"
                >
                  <div class="ts-notifications__row-container">
                    <span class="ts-notifications-title">
                      <i
                        v-if="scope.row.capturedType === 9"
                        class="fas fa-check-circle"
                      ></i>
                      <i
                        v-if="
                          scope.row.capturedType === 10 ||
                            scope.row.capturedType === 11 ||
                            scope.row.capturedType === 12
                        "
                        class="fas fa-handshake"
                      ></i>
                      <i
                        v-if="
                          scope.row.capturedType === 6 ||
                            scope.row.capturedType === 3 ||
                            scope.row.capturedType === 44
                        "
                        class="fas fa-layer-group"
                      ></i>
                      <strong>{{ scope.row.capturedTypeName }}</strong>
                    </span>
                    <span class="ts-notifications-info">
                      <span
                        class="ts-notifications-message"
                        v-html="scope.row.message"
                      >
                      </span>
                      <span
                        v-if="scope.row.readInd === false"
                        style="color: white"
                        class="ts-notifications-time"
                        >{{ scope.row.updated }}</span
                      >
                      <span
                        v-else
                        style="color: #444 !important"
                        class="ts-notifications-time"
                        >{{ scope.row.updated }}</span
                      >
                    </span>
                  </div>
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column width="65">
            <template slot-scope="scope">
              <el-button
                class="ts-btn-small invt-action"
                @click="removeNotification(scope.$index, scope.row)"
                ><i class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-row>
          <el-col :xl="19" :lg="19" :md="19" :sm="19">
            <el-pagination
              style="padding-top: 20px"
              layout="prev, pager, next"
              :total="notificationsCount"
              :page-size="resultsPerPage"
              :current-page.sync="pageNumber"
              @current-change="getNotifications"
              @prev-click="getNotifications"
              @next-click="getNotifications"
            >
            </el-pagination>
          </el-col>
        </el-row>

        <TSLoading
          :active="isNotificationsLoading"
          :defaultMessage="'Please wait...'"
          :altMessage="
            'Please hold on for a moment while we process the data...'
          "
        />
      </el-drawer>
      <aside class="ts-app-shell--side">
        <div>
          <div class="ts-app-shell--side_header">
            <a href="/apprentice-dashboard" class="logo">
              <img
                src="~../assets/img/logo_white.svg"
                alt="TalentSensus"
                class="logo_icon"
              />
            </a>
          </div>
          <nav class="ts-app-shell--side_nav">
            <router-link to="/apprentice-dashboard">
              <span><i class="fas fa-home"></i></span>
              <span>My Hub</span>
            </router-link>
            <router-link to="/a-skills-passport/landing">
              <span><i class="fas fa-passport"></i></span>
              <span>Skills Passport</span>
            </router-link>
            <el-menu ref="smartRecruitMenu">
              <el-submenu index="1">
                <template slot="title">
                  <i class="fas fa-user-friends"></i> Smart Recruit
                </template>
                <router-link
                  to="/apprentice-smart-recruit/interested-companies-dashboard"
                >
                  <span><i class="fas fa-building"></i></span>
                  <span>Interested Companies</span>
                </router-link>
                <router-link
                  to="/apprentice-smart-recruit/my-applications-dashboard"
                >
                  <span><i class="fas fa-list"></i></span>
                  <span>My Expressed Interest</span>
                </router-link>
              </el-submenu>
            </el-menu>
          </nav>
          <div class="app-version">
            <span style="padding-left: 20px">
              © TalentSensus {{ appYear }} v{{ appVersion }}
            </span>
          </div>
        </div>
      </aside>
      <div class="ts-app-shell--main white-bg">
        <header class="ts-app-header">
          <div class="ts-app-header--actions">
            <!-- <div class="ts-app-header--actions_profile">
              <span class="cs-title"> {{ currentUser.FullName}} </span>
            </div> -->
            <div class="ts-app-header--actions_logout">
              <span class="ts-avatar-name">
                <el-dropdown trigger="click" @command="handleCommand">
                  <el-button type="text">
                    <img
                      v-if="flag === 'en-US'"
                      src="~../assets/img/usa-circle.svg"
                      width="30px"
                    />
                    <img
                      v-else
                      src="~../assets/img/uk-circle.svg"
                      width="30px"
                    />
                  </el-button>
                  <el-dropdown-menu
                    slot="dropdown"
                    style="width: 150px; text-align: center"
                  >
                    <!-- <el-dropdown-item>Choose Location</el-dropdown-item> -->
                    <div
                      style="
                        background: #f5f7fb;
                        margin-top: -5px;
                        margin-bottom: -5px;
                      "
                    >
                      <span style="font-size: 15px">Choose Location</span>
                    </div>
                    <el-dropdown-item
                      class="el-dropdown-menu__item--divided"
                      command="en-US"
                      ><span
                        ><img src="~../assets/img/usa-square.svg" /> USA</span
                      ></el-dropdown-item
                    >
                    <el-dropdown-item
                      class="el-dropdown-menu__item--divided"
                      command="en-uk"
                      ><span
                        ><img src="~../assets/img/uk-square.svg" /> UK</span
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
              <span class="ts-notifications" @click="showNotifications">
                <span id="notification_admin" style="display: none"></span
                ><i class="fas fa-bell"></i>
              </span>

              <span class="menu-divider"></span>
              <div class="user-actions">
                <span class="ts-avatar">
                  {{ currentUser.fullName.slice(0, 1) }}
                </span>
                <span class="ts-avatar-name">
                  <el-dropdown trigger="click">
                    <el-button type="text"
                      >{{ currentUser.fullName }}
                      <i class="fas fa-chevron-down"></i
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="el-dropdown-menu__item"
                        ><span @click="goHome"
                          ><i class="fas fa-home"></i>My Hub</span
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="el-dropdown-menu__item"
                        ><span @click="goToUserProfileSettings"
                          ><i class="fas fa-user-cog"></i>Public
                          Profile/Resume</span
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="el-dropdown-menu__item--divided"
                        ><span @click="complateMySGA"
                          ><i class="fas fa-hourglass-half"></i>Complete Skills
                          Profile</span
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="el-dropdown-menu__item--divided"
                        ><span @click="doLogout()"
                          ><i class="fas fa-sign-out-alt"></i>Logout</span
                        ></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </div>
            </div>
          </div>
        </header>

        <!-- <loading 
            :active.sync="isShellLoading"
            :can-cancel="false"
            :is-full-page="false">
            <div class="ts-logo-loader" slot="default">
              <img class="ts-logo-loader__first" src="~../assets/img/logo_ts.svg" alt="TalentSensus" />
              <img class="ts-logo-loader__second" src="~../assets/img/logo_us.svg" alt="TalentSensus" />
            </div>
        </loading> -->

        <router-view @isloading="doloading"></router-view>
      </div>
    </main>

    <!-- Negate the isValidSession value of false to show the session update modal -->
    <SessionUpdate
      :showModal="!isValidSession"
      @close-modal="closeSessionUpdateModal"
    />

  </div>
</template>

<script>
import Vue from "vue";
import SessionUpdate from "@/components/SessionUpdate.vue";
import loginUtils from "@/utils/login.utils";

import {
  LifeBuoyIcon,
  StarIcon,
  LayersIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
  SettingsIcon,
  LockIcon
} from "vue-feather-icons";

export default {
  data() {
    return {
      isValidSession: loginUtils.checkLoginStatus(),
      isShellLoading: false,
      showDiagnosticModal: false,
      diagnosticBeginModal: false,
      debugid: null,
      notifications: [],
      table: false,
      connection: "",
      shownotification: false,
      huburl: process.env.VUE_APP_MESSAGE_BASE_URI,
      smartRecruitMenu: [],
      flag: true,
      pageNumber: 1,
      resultsPerPage: 50,
      isNotificationsLoading: false,
      notificationsCount: 100,
      multipleSelection: [],
      isSgaComplete: false
    };
  },
  components: {
    LifeBuoyIcon,
    StarIcon,
    UserIcon,
    LayersIcon,
    UserPlusIcon,
    UsersIcon,
    SettingsIcon,
    LockIcon,
    SessionUpdate
  },
  created() {
    this.$store.dispatch("account/getuserfamiliarity").then(res => {
      this.isSgaComplete = res.sgaCompleted;
    });

    this.$store
      .dispatch("sga/getsga")
      .then(res => {
        // setting the locale
        var lslocale = localStorage.getItem("locale");
        if (lslocale != null) {
          if (lslocale == "en") {
            this.flag = "en-US";
            localStorage.setItem("locale", "en-US");
          } else {
            this.flag = lslocale;
          }
        } else {
          localStorage.setItem("locale", "en-US");
        }

        // set exchange rate
        var locale = localStorage.getItem("locale");
        this.$i18n.locale = locale;
      })
      .catch(() => {
        localStorage.setItem("locale", "en-US");
        this.flag = "en-US";
      });

    axios
      .get(`${process.env.VUE_APP_API_BASE_URI_V1}ExchangeRate`)
      .then(res => {
        Vue.prototype.$ExchangeRates = res;
      });

    this.getNotifications();

    //TODO: Reevaluate code below
    // this.initializeSignalR();
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    },
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
    appYear() {
      return process.env.VUE_APP_YEAR;
    },
    sessionChecker() {
      return process.env.VUE_APP_SESSION_CHECKER_INTERVAL;
    },
  },
  methods: {
    complateMySGA() {
      this.$router.push({ name: "sgaIntro" });
      this.showMatchModal = false;
    },
    goHome() {
      this.$router.push({ name: "apprentice-dashboard" });
      this.showMatchModal = false;
    },
    doLogout() {
      window.localStorage.removeItem("shouldShowDiagnosticModal");

      if (sessionStorage.getItem("fromSuperAdmin") != null) {
        this.connection.invoke("ApprenticeDebugEnded", "").catch(function(err) {
          return console.error(err.toString());
        });
      }

      if (localStorage.getItem("token") === null) {
        window.location = window.location.origin + "/apprentice-login";
      }

      this.$store.dispatch("account/logout").then(() => {
        window.location = window.location.origin + "/apprentice-login";
      });
    },
    doloading(isLoading) {
      this.isShellLoading = isLoading;
    },
    //TODO: Reevaluate code below
    // initializeSignalR() {
    //   this.connection = new signalR.HubConnectionBuilder()
    //     .withUrl(this.huburl, {
    //       transport:
    //         signalR.HttpTransportType.WebSockets |
    //         signalR.HttpTransportType.LongPolling,
    //       "content-type": "application/json",
    //       accessTokenFactory: () => localStorage.getItem("token"),
    //     })
    //     .build();

    //   this.connection.on("EmployeeAdded", () => {
    //     let src = "~../assets/alerts/sms-alert-3.mp3";
    //     let audio = new Audio(src);
    //     audio.play();
    //     this.onMessageReceived();
    //   });

    //   this.connection.start().catch(function (err) {
    //     return console.error(err.toString());
    //   });
    // },
    getNotifications() {
      this.isNotificationsLoading = true;

      this.$store
        .dispatch("notification/getNotificationsByUser", {
          userId: this.currentUser.id,
          pageNumber: this.pageNumber,
          resultsPerPage: this.resultsPerPage
        })
        .then(res => {
          this.notifications = res.results;
          this.notificationsCount = res.resultsCount;
          this.isNotificationsLoading = false;
          if (
            this.notifications.some(c => {
              return !c.readInd;
            })
          ) {
            this.showNotificationIndicator(true);
          } else {
            this.showNotificationIndicator(false);
          }
        })
        .catch(() => {
          this.isNotificationsLoading = false;
        });
    },
    onMessageReceived() {
      this.$store
        .dispatch("notification/getNotificationsByUser", {
          userId: this.currentUser.id,
          pageNumber: this.pageNumber,
          resultsPerPage: this.resultsPerPage
        })
        .then(res => {
          console.log("res.results", res.results);
          this.notifications = res.results;
          this.notificationsCount = res.resultsCount;
          if (
            (Date.now() -
              new Date(
                this.notifications[0].updated.substring(
                  0,
                  this.notifications[0].updated.length - 3
                )
              )) /
              1000 <
            10
          ) {
            this.showNotificationIndicator(true);
          } else {
            this.showNotificationIndicator(false);
          }
        });
    },
    showNotificationIndicator(show) {
      var notif = document.getElementById("notification_admin");
      notif.style.display = show ? "block" : "none";
    },
    showNotifications() {
      this.table = true;
      document.documentElement.style.overflow = "hidden"; // firefox, chrome
      document.body.scroll = "no"; // ie only

      this.getNotifications();
    },
    readNotification(item) {
      if (item.readInd) {
        this.goToNotificationAdditionalAction(item);
      } else {
        this.$store
          .dispatch("notification/readnotification", item.id)
          .then(() => {
            //this.showNotifications();
            this.goToNotificationAdditionalAction(item);
          });
      }
    },
    goToNotificationAdditionalAction(item) {
      switch (item.capturedType) {
        case 44:
          this.table = false;
          document.documentElement.style.overflow = "scroll";
          this.$router.push({ name: "sgaEducation" });
          break;
      }
    },
    toggleSmartRecruitMenu() {
      if (
        this.$route.matched.find(
          c =>
            c.path ===
            "/apprentice-smart-recruit/interested-companies-dashboard"
        ) === undefined &&
        this.$route.matched.find(
          c =>
            c.path ===
            "/apprentice-smart-recruit/interested-companies-dashboard/statusboard/:status"
        ) === undefined &&
        this.$route.matched.find(
          c => c.path === "/apprentice-smart-recruit/my-applications-dashboard"
        ) === undefined &&
        this.$route.matched.find(
          c =>
            c.path ===
            "/apprentice-smart-recruit/my-applications-dashboard/my-applications"
        ) === undefined
      ) {
        this.$refs.smartRecruitMenu.close("1");
      } else {
        this.$refs.smartRecruitMenu.open("1");
      }
    },
    handleCommand(command) {
      this.$i18n.locale = command;
      this.flag = command;
      localStorage.setItem("locale", command);
    },
    reloadScrollbar(done) {
      document.documentElement.style.overflow = "auto"; // firefox, chrome
      document.body.scroll = "yes"; // ie only
      done();
    },
    tableRowClassName({ row, rowIndex }) {
      if (!row.readInd) {
        return "notif_unread";
      }
      return "";
    },
    goToUserProfileSettings() {
      if (this.isSgaComplete != true) {
        this.$confirm(
          `You must complete your Skills Profile first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {});
      } else this.$router.push({ name: "ApprenticeProfilePageSetting" });
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach(element => {
        this.multipleSelection.push(element);
      });
    },
    removeNotification(index, row) {
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">Are you sure you want to remove this notification?</p>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.isNotificationsLoading = true;
        this.$store
          .dispatch("notification/removeNotification", row.id)
          .then(() => {
            this.getNotifications();
            this.$message.success("Notification removed successfully!");
            this.isNotificationsLoading = false;
          })
          .catch(() => {
            this.isNotificationsLoading = false;
          });
      });
    },
    removeNotifications() {
      var msg = "";
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">Are you sure you want to remove selected notifications?</p>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        const selectedIds = this.multipleSelection.map(i => i.id);

        this.isNotificationsLoading = true;
        if (this.multipleSelection.length > 1) {
          msg = "Notifications removed successfully!";
        } else {
          msg = "Notification removed successfully!";
        }
        this.$store
          .dispatch("notification/removeSelectedNotifications", selectedIds)
          .then(() => {
            this.getNotifications();
            this.$message.success(msg);
            this.isNotificationsLoading = false;
          })
          .catch(() => {
            this.isNotificationsLoading = false;
          });
      });
    },
    closeSessionUpdateModal() {
      this.isValidSession = true;
    },
  },
  beforeUpdate() {
    this.toggleSmartRecruitMenu();
  },
  mounted() {
    setInterval(() => {
      this.isValidSession = loginUtils.checkLoginStatus();
    }, this.sessionChecker); // Check every set time for login status
    
    this.toggleSmartRecruitMenu();
  }
};
</script>

<style scoped>
.cs-title {
  font-size: 20px;
  color: #00c8dc;
  text-transform: capitalize;
}

#notification_admin {
  background: #28a745;
  color: #fff;
  margin-left: 10px;
  font-size: 12px;
  text-transform: uppercase;
  padding: 0.25em 0.4em;
  font-size: 70%;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 10rem;
  margin-bottom: -5px;
}

.fa-bell {
  animation-name: swing;
  animation-duration: 3s;
  animation-delay: 2s;
  animation-iteration-count: 5;
}

.virus.router-link-active span i {
  color: red !important;
}

.app-version {
  color: #808080;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  font-size: 13px;
}
</style>
